// extracted by mini-css-extract-plugin
module.exports = {"list":"SingleColumn_list__3IgR-"};